import Page from "webPage/Page";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";
import PromiseHelper from "base/PromiseHelper";
import RecaptchaHelper from "util/RecaptchaHelper";

Page.register('/contact-us', () => {

    RecaptchaHelper.load().then(() => {
        console.log("Recaptcha loaded");
        RecaptchaHelper.init($(".js-contact-form"));
    });


    FormValidator.attach($(".js-contact-form"), {inputOptions: {operator: "your"}}).on("input:invalid", ({input}) => {
        input.$input.parents(".form__row").addClass("form__row--invalid");
    }).on("input:valid", ({input}) => {
        input.$input.parents(".form__row").removeClass("form__row--invalid");
    }).on("submit", ($form) => {
        let $btn = $form.find("button[type=submit]");
        if ($btn.is(".btn--loading")) return;
        $btn.addClass("btn--loading");
        $(".js-contact-form").removeClass("form--success form--error");
        let timed = PromiseHelper.timed_promise(500);

        Promise.all([
            RecaptchaHelper.validate().then((captcha) => {
                return Ajax.post("contact", '', $.extend({captcha}, $form.serializeJSON()), Ajax.WEBSITE);
            }),
            timed,
        ]).then(() => {
            $btn.removeClass("btn--loading");
            $(".js-contact-form").addClass("form--success").removeClass("form--error");
        }).catch((e) => {
            timed.then(() => {
                $btn.removeClass('btn--loading');
                $(".js-contact-form").addClass("form--error").removeClass("form--success form--validation-error");
                if (e.data && e.data.exception === 'HttpBadRequest') {
                    $(".js-contact-form").addClass("form--validation-error");
                }
            });
        });
    });

    $("body").on("click", ".js-retry-contact", () => {
        let $form = $(".js-contact-form");
        if (!$form.is(".form--validation-error")) {
            $form.submit()
        }
        $form.removeClass("form--success form--error form--validation-error");
        grecaptcha.reset();
        return false;
    });
});
